import React, { useEffect, useRef, createElement } from 'react';
export function VideoPlayer() {
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    // Add Wistia scripts
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    const embedScript = document.createElement('script');
    embedScript.src = 'https://fast.wistia.com/embed/cexknjoao8.js';
    embedScript.async = true;
    embedScript.type = 'module';
    document.head.appendChild(playerScript);
    document.head.appendChild(embedScript);
    // Clean up
    return () => {
      document.head.removeChild(playerScript);
      document.head.removeChild(embedScript);
    };
  }, []);
  return <div ref={containerRef} className="relative w-full aspect-video" data-id="element-424">
      <style data-id="element-425">
        {`
          wistia-player[media-id='cexknjoao8']:not(:defined) { 
            background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/cexknjoao8/swatch'); 
            display: block; 
            filter: blur(5px); 
            padding-top: 56.25%; 
          }
        `}
      </style>
      <wistia-player media-id="cexknjoao8" aspect="1.7777777777777777" autoplay="false" data-id="element-426"></wistia-player>
    </div>;
}